import { countryToCurrency } from '../dropdownOptions';
import { DEFAULT_PRICING_MODEL } from '../pages/constants';
import { CountryCode, Customer, Option, TangoTeamProduct } from '../pages/types';

export const isCanadianCustomer = (customer: Customer) => {
  return customer.default_country === CountryCode.CA;
};

/**
 * Pricing models are currency specific, so only the ones priced in the selected
 * country's currency are meaningful for that country.
 */
export const getPricingModelOptionsForCountry = (
  products: TangoTeamProduct[] | undefined,
  country: string
): Option[] => {
  const currency = countryToCurrency[country];
  const pricingModelSet = new Set<string>();

  for (const product of products ?? []) {
    for (const price of Object.values(product.prices ?? {})) {
      if (price?.pricing_model_name && price.currency === currency) {
        pricingModelSet.add(String(price.pricing_model_name));
      }
    }
  }

  return Array.from(pricingModelSet).map((v) => ({ label: v, value: v }));
};

export const getDefaultPricingModelOption = (pricingModelOptions: Option[]): Option =>
  pricingModelOptions.find((option) => option.value === DEFAULT_PRICING_MODEL) ??
  pricingModelOptions[0] ?? { label: DEFAULT_PRICING_MODEL, value: DEFAULT_PRICING_MODEL };
